import { useTranslation } from 'react-i18next';

export const keyPrefix = 'full_frame_detections_with_settings';
export const useFullFrameDetectionsWithSettingsTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Лицо и тело',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Face and body',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Rosto e corpo',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Rostro y cuerpo',
    },
  },
}) as Record<string, unknown>;
